import { CpscValidator } from './cpscValidator';
import { CpscReferenceValidator } from './cpscReferenceValidator';
import { CpscFullValidator } from './cpscFullValidator';
import { CpscDisclaimValidator } from './cpscDisclaimValidator';

/**
 * Pre-configured CPSC validator instance with all sub-validators registered
 *
 * Sub-validators:
 * - CpscDisclaimValidator: Validates DISCLAIM processing type
 * - CpscReferenceValidator: Validates REF processing type
 * - CpscFullValidator: Validates FULL (FCP/FGC) processing type
 */
export const registeredCpscValidator = new CpscValidator([
  new CpscDisclaimValidator(),
  new CpscReferenceValidator(),
  new CpscFullValidator(),
]);
